const styles = (theme) => ({
  containerModal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: "16px",

    width: " 90%",
    maxWidth: "1000px",
    height: "700px",
    maxHeight: "90vh",
    overflow: "hidden",
    padding: "20px 40px",
  },
  BoxExitModal: {
    position: "absolute",
    top: 0,
    right: 0,
    width: "50px",
    height: "50px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  chip: {
    color: theme.palette.white.main,
    fontWeight: "bold",
    fontSize: "0.75rem",
    height: 24,
    flexShrink: 0,
    maxWidth: "200px",
  },
  titleTag: {
    display: "block",
    color: "text.secondary",
    fontWeight: "bold",
    mb: 0.5,
    whiteSpace: "nowrap", // Garante que o título não quebre linha
  },
  containerColors: {
    display: "flex",
    gap: 1,
    alignItems: "center",
    flexWrap: "nowrap", // Impede que os círculos pulem para a linha de baixo
  },
  iconButtonColor: {
    width: 26,
    height: 26,
    padding: 0,

    transition: "all 0.2s ease-in-out",
    "&:hover": {
      backgroundColor: "transparent",
      transform: "scale(1.1)",
    },
  },
  containerNomePermissao: {
    display: "flex",
    width: "100%",
    gap: 3,
    alignItems: "center",
    mt: 2,
  },
  titlePermissao: {
    display: "block",
    fontWeight: "bold",
  },
  title: { fontWeight: "bold", fontSize: "20px" },
  boxBody: { display: "flex", gap: 3, alignItems: "flex-start" },
  containerBody: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    flexGrow: 1,
  },
  boxPermissao: { display: "flex", alignItems: "center", gap: 1 },
  paperBody: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    mt: 3,
    borderRadius: "16px",
    p: 2,
    backgroundColor: theme.palette.background.wallpaper,
  },
  containerBox: {
    p: 2,
    overflow: "auto",
    maxHeight: "500px",
    gap: 2,
    display: "flex",
    flexDirection: "column",
  },
});
export default styles;
